export const requiredField = 'This field is required'
export const invalidEmail = 'Invalid email address format'
export const invalidPhoneNumberFormat = 'Invalid phone number format'
export const baseXeroEmployeeValidationMessage =
  'Uh oh! We are unable to create an new employee in Xero without '
